module.exports = __webpack_public_path__ + "img/songfengkou.5c2c4aae.png";